// @ts-strict-ignore
export class LocationShim implements Location {
  declare ancestorOrigins: DOMStringList;
  declare hash: string;
  declare host: string;
  declare hostname: string;
  declare href: string;
  declare origin: string;
  declare pathname: string;
  declare port: string;
  declare protocol: string;
  declare search: string;
  toString(): string {
    return this.href;
  }

  constructor() {
    this.assign(`https://localhost`);
  }

  assign(urlString: string): void {
    if (urlString.startsWith(`/`)) {
      urlString = `${this.origin}${urlString}`;
    } else if (urlString.startsWith(`#`)) {
      const prevUrl = new URL(this.href);
      prevUrl.hash = urlString;
      urlString = prevUrl.href;
    }
    const url = new URL(urlString);

    const {
      hash = ``,
      host = ``,
      hostname = ``,
      href = ``,
      origin = ``,
      pathname = ``,
      search = ``,
      protocol = ``,
      port = ``,
    } = url;
    Object.assign(this, {hash, host, hostname, href, origin, pathname, search, protocol, port});
  }
  reload(_?: any) {
    throw new Error(`Method not implemented.`);
  }
  replace(_?: string): void {
    throw new Error(`Method not implemented.`);
  }
}
